import { gql } from '@apollo/client'

export const galleryImagesDownloadIncrementMutation = gql`
  mutation GalleryImagesDownloadIncrement($_id: String!) {
    galleryImagePopularity(_id: $_id, type: downloads)
  }
`
